import { Model } from "@vuex-orm/core"
import { notify } from "@/services/notification"

export default class ConnectedUser extends Model {
  static get entity() {
    return "connectedUser"
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      email: this.attr(null),
      roles: this.attr([]),
      password: this.attr(null),
    }
  }

  // Get the current user's profile data
  static async getSelfProfile() {
    return await this.api()
      .get(`/profile`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error.response.data.error ?? "Erreur")
      })
  }

  static async updateProfile(user) {
    return await this.api()
      .put(`/profile`, user, { dataKey: "data" })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.error ?? "Erreur")
      })
  }
}
